import React from 'react';
import { HistoryTable } from '@/pages/Admin/area-notifications/HistoryTable';
import { useAreaBroadcastsList } from '@/pages/Admin/area-notifications/api';
import type { Env } from '@/pages/Admin/shared';
import AreaBroadcastsStats from './AreaBroadcastsStats';
import AreaBroadcastsTrendChart from './AreaBroadcastsTrendChart';

interface AreaBroadcastsSectionProps {
  env: Env;
}

function AreaBroadcastsSection({ env }: AreaBroadcastsSectionProps): React.ReactElement {
  // Single fetch — feeds the stats grid, the weekly chart, and the table.
  // HistoryTable's `items` prop opts it out of its own internal fetch.
  const { items, loading, error } = useAreaBroadcastsList({ env, limit: 50 });

  return (
    <div className="space-y-4">
      <AreaBroadcastsStats items={items} loading={loading} />
      <AreaBroadcastsTrendChart items={items} loading={loading} />

      <div className="bg-gray-900 border border-gray-800 rounded-xl overflow-hidden">
        <div className="px-5 py-3.5 border-b border-gray-800">
          <h3 className="text-sm font-semibold text-white tracking-tight">Recent Broadcasts</h3>
          <p className="text-xs text-gray-500 mt-0.5">Most recent 50 admin-sent area notifications</p>
        </div>
        <div className="overflow-x-auto">
          <HistoryTable env={env} items={items} loading={loading} error={error} />
        </div>
      </div>
    </div>
  );
}

export default AreaBroadcastsSection;
